module.exports = __webpack_public_path__ + "img/img_thumb_0204.519235ab.png";